import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import menuNav from './modules/menuNav'
import language from './modules/language'
import currency from './modules/currency'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    menuNav,
    language,
    currency
  }
})
